<template>
  <div class="formulario-modelo">
    <header class="superior">
      <div class="header-flex">
        <h2 class="titulo-ficha">Ficha Estadística</h2>
        <button class="btn salir" @click="idInstrumento != null ? emit('cerrar') : router.back()">
          {{ idInstrumento != null ? 'Cerrar' : 'Volver' }}
        </button>
      </div>
      <div v-if="nombreVersion || rutaComponente?.length || nombreIndicador" class="ctx-strip">
        <span v-if="nombreVersion" class="ctx-version">{{ nombreVersion }}</span>
        <template v-if="rutaComponente?.length">
          <div v-for="(nodo, i) in rutaComponente" :key="i" class="ctx-ruta-nodo">
            <span v-if="nodo.tipo" class="ctx-ruta-tipo">{{ nodo.tipo }}</span>
            <span v-if="nodo.ordinal" class="ctx-ruta-ordinal">{{ nodo.ordinal }}</span>
            <span class="ctx-ruta-nombre">{{ nodo.nombre }}</span>
          </div>
        </template>
        <div v-if="nombreIndicador" class="ctx-ruta-nodo ctx-indicador-row">
          <span class="ctx-ruta-tipo">Indicador</span>
          <span class="ctx-indicador">{{ nombreIndicador }}</span>
        </div>
      </div>
      <div class="divider"></div>
    </header>

    <!-- Tabla de fichas existentes -->
    <div class="contenedor-tabla">
      <div v-if="loading" class="info">Cargando fichas estadísticas...</div>
      <table class="lista-tabla" v-else-if="fichasUnicas.length">
        <thead>
          <tr>
            <th>NO.</th>
            <th>ESTADO</th>
            <th>DOCUMENTO</th>
            <th>ESCALA</th>
            <th>FUENTE</th>
            <th>NOTA</th>
            <th>ACCIÓN</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(f, i) in fichasUnicas" :key="f.id_ficha">
            <td>{{ i + 1 }}</td>
            <td><span :class="['badge', `badge-${f.estado}`]">{{ f.estado }}</span></td>
            <td class="doc-celda">
              <template v-if="renombrandoId === f.id_ficha">
                <div class="rename-row">
                  <input v-model="nuevoNombre" class="input-nombre" @keyup.enter="guardarNombre(f.id_ficha!)" @keyup.escape="cancelarRename" placeholder="Nombre del documento" />
                  <button class="btn guardar btn-sm-accion" @click="guardarNombre(f.id_ficha!)">OK</button>
                  <button class="btn salir btn-sm-accion" @click="cancelarRename">&#x2715;</button>
                </div>
              </template>
              <template v-else-if="f.origen_documento === 'cloudinary' || f.origen_documento === 'externo'">
                <a :href="f.documento" target="_blank" rel="noopener" class="link-doc">{{ f.nombre_visible || 'Ver documento' }}</a>
                <!-- Descarga aparte de «ver»: el enlace de arriba abre el
                     archivo, este lo guarda con su nombre real. -->
                <a
                  v-if="f.url_descarga && f.origen_documento === 'cloudinary'"
                  :href="f.url_descarga"
                  class="link-descargar"
                  :title="`Descargar ${f.nombre_visible || 'archivo'}`"
                >&#11015;</a>
                <span v-if="f.origen_documento === 'externo'" class="badge-origen externo">externo</span>
                <span v-if="f.formato" class="badge-formato">{{ f.formato.toUpperCase() }}</span>
              </template>
              <template v-else-if="f.origen_documento === 'desconocido'">
                <span class="badge-origen desconocido">No disponible</span>
              </template>
              <template v-else-if="!f.origen_documento && f.documento && f.documento !== 'sin-documento' && f.documento !== 'pendiente-upload'">
                <a :href="f.documento" target="_blank" rel="noopener" class="link-doc">Ver documento</a>
              </template>
              <span v-else>-</span>
            </td>
            <td>{{ f.escala_cuantitativa }}</td>
            <td>{{ f.fuente_datos }}</td>
            <!-- La nota que calculó la ficha, visible sin abrir nada: es la
                 que verá el calificador experto. -->
            <td class="celda-nota">
              <template v-if="f.calculo?.nota != null">
                <span class="nota-chip">{{ f.calculo.nota.toFixed(2) }}</span>
                <small class="nota-metodo">{{ etiquetaMetodo(f.metodo_calculo) }}</small>
              </template>
              <span v-else class="nota-chip nota-chip--vacia">—</span>
            </td>
            <td class="acciones-ficha">
              <button v-if="!fichasRecienCreadas.includes(f.id_ficha!)" class="btn guardar btn-sm-accion" @click="reutilizarFicha(f)">Reutilizar</button>
              <button
                v-if="f.id_ficha && renombrandoId !== f.id_ficha && f.documento && f.documento !== 'sin-documento' && f.documento !== 'pendiente-upload'"
                class="btn guardar btn-sm-accion"
                @click="iniciarRenombrar(f)"
              >Renombrar</button>
              <label class="btn guardar btn-upload" :class="{ disabled: subiendo === f.id_ficha }">
                {{ subiendo === f.id_ficha ? 'Subiendo...' : 'Subir archivo' }}
                <input
                  type="file"
                  accept=".pdf,.doc,.docx,.xls,.xlsx,.csv,.png,.jpg,.jpeg,.txt"
                  hidden
                  :disabled="subiendo === f.id_ficha"
                  @change="subirArchivo(f.id_ficha!, $event)"
                />
              </label>
              <button class="btn guardar btn-sm-accion" @click="abrirCalculo(f.id_ficha!)">Calcular nota</button>
              <button class="btn salir" @click="abrirConfirmacionEliminar(f.id_ficha)">Eliminar</button>
            </td>
          </tr>
        </tbody>
      </table>

      <div v-if="fichaCalculando" class="panel-calculo">
        <div class="pc-cab">
          <h3>Cálculo de la nota · ficha #{{ fichaCalculando }}</h3>
          <button type="button" class="btn salir btn-sm-accion" @click="cerrarCalculo">Cerrar</button>
        </div>

        <div class="pc-metodo">
          <label>¿Cómo se calcula?</label>
          <select v-model="metodoDelPanel" class="form-control" @change="guardarMetodoDelPanel">
            <option :value="null">— A mano, sin cálculo —</option>
            <option value="por_periodos">Por periodos (valorar año por año)</option>
            <option value="directo">Directo (logro sobre meta)</option>
          </select>
          <template v-if="metodoDelPanel === 'directo'">
            <input
              type="number" step="0.01" v-model.number="logroDelPanel"
              class="form-control input-corto" placeholder="Logro"
            />
            <input
              type="number" step="0.01" v-model.number="metaDelPanel"
              class="form-control input-corto" placeholder="Meta"
            />
            <button type="button" class="btn guardar btn-sm-accion" @click="guardarMetodoDelPanel">
              Guardar
            </button>
          </template>
        </div>

        <table v-if="periodos.length && metodoDelPanel === 'por_periodos'" class="tabla-periodos">
          <thead>
            <tr><th>Periodo</th><th>Valoración</th><th>Puntos</th><th></th></tr>
          </thead>
          <tbody>
            <tr v-for="p in periodos" :key="p.id_valoracion">
              <td>{{ p.periodo }}</td>
              <td>{{ p.valoracion }}</td>
              <td>{{ puntosDe(p.valoracion) ?? '—' }}</td>
              <td><button type="button" class="btn-quitar" @click="quitarPeriodo(p.id_valoracion)">×</button></td>
            </tr>
          </tbody>
        </table>
        <p v-else-if="metodoDelPanel === 'por_periodos'" class="sin-periodos">
          Aún no se ha registrado ningún periodo.
        </p>

        <div class="nuevo-periodo" v-if="metodoDelPanel === 'por_periodos'">
          <input v-model="nuevoPeriodo.periodo" class="form-control" placeholder="Año 1" />
          <select v-model="nuevoPeriodo.valoracion" class="form-control">
            <option value="" disabled>Valoración…</option>
            <option v-for="e in etiquetas" :key="e.valoracion" :value="e.valoracion">
              {{ e.valoracion }} ({{ e.puntos }})
            </option>
          </select>
          <button
            type="button"
            class="btn guardar btn-sm-accion"
            :disabled="!nuevoPeriodo.periodo || !nuevoPeriodo.valoracion"
            @click="agregarPeriodo"
          >
            Agregar
          </button>
        </div>

        <!-- Nota calculada -->
        <div v-if="notaCalculada" class="nota-cuantitativa">
          <template v-if="notaCalculada.nota != null">
            <div class="nc-cab">
              <span class="nc-valor">{{ notaCalculada.nota.toFixed(2) }}</span>
              <span class="nc-lbl">
                {{ notaCalculada.desglose?.porcentaje_cumplimiento?.toFixed(2) }}% de cumplimiento
                <template v-if="notaCalculada.desglose?.tendencia">
                  · {{ notaCalculada.desglose.tendencia.tendencia }}
                </template>
              </span>
            </div>
            <p v-if="notaCalculada.desglose?.topado_al_100" class="nc-aviso">
              El cumplimiento real fue {{ notaCalculada.desglose.porcentaje_sin_tope }}%; superar la meta
              no da más del máximo, así que se toma 100%.
            </p>
            <p v-if="notaCalculada.desglose?.valoraciones_no_reconocidas?.length" class="nc-aviso">
              No se contaron: {{ notaCalculada.desglose.valoraciones_no_reconocidas.join(', ') }}
            </p>
          </template>
          <p v-else class="nc-sin">{{ notaCalculada.motivo }}</p>
        </div>
      </div>
      <p v-else class="mensaje-vacio">No hay fichas cuantitativas registradas.</p>
    </div>

    <!-- Formulario nueva ficha -->
    <form class="ficha-form" @submit.prevent="guardarFicha">
      <h3>Nueva Ficha</h3>

      <!-- Estado: Existe / No existe -->
      <div class="fila">
        <label>¿La Ficha existe? *</label>
        <div class="toggle-group">
          <label class="toggle-label">
            <input type="radio" v-model="formData.estado" value="existe" required />
            ✓ Existe
          </label>
          <label class="toggle-label">
            <input type="radio" v-model="formData.estado" value="no_existe" required />
            ✗ No existe
          </label>
        </div>
      </div>

      <!-- Subir archivo -->
      <div class="fila">
        <label>Subir archivo de evidencia</label>
        <div class="upload-area" :class="{ disabled: formData.estado === 'no_existe' }">
          <label class="upload-label" :class="{ disabled: formData.estado === 'no_existe' }">
            <input
              type="file"
              ref="fileInputRef"
              accept=".pdf,.doc,.docx,.xls,.xlsx,.csv,.png,.jpg,.jpeg,.txt"
              hidden
              :disabled="formData.estado === 'no_existe'"
              @change="onFileSelected"
            />
            <span class="upload-icon">&#128206;</span>
            <span v-if="archivoSeleccionado">{{ archivoSeleccionado.name }}</span>
            <span v-else>Seleccionar archivo (PDF, DOC, XLS, IMG, etc.)</span>
          </label>
          <button
            v-if="archivoSeleccionado"
            type="button"
            class="btn-quitar"
            @click="quitarArchivo"
          >Quitar</button>
        </div>
      </div>

      <!-- Documento (enlace manual alternativo) -->
      <div class="fila">
        <label>O enlace del documento</label>
        <input
          type="url"
          v-model="formData.documento"
          :disabled="formData.estado === 'no_existe' || !!archivoSeleccionado"
          placeholder="https://..."
          class="form-control"
        />
        <small v-if="archivoSeleccionado" class="hint">El enlace se generará automáticamente al subir el archivo.</small>
      </div>

      <!-- Fuente de datos - REQUERIDO cuando existe -->
      <div class="fila">
        <label>Fuente de datos{{ formData.estado !== 'no_existe' ? ' *' : '' }}</label>
        <input
          type="text"
          v-model="formData.fuente_datos"
          :required="formData.estado !== 'no_existe'"
          :disabled="formData.estado === 'no_existe'"
          placeholder="De dónde provienen los datos"
          class="form-control"
        />
      </div>

      <!-- Escala cuantitativa - REQUERIDO cuando existe -->
      <div class="fila">
        <label>Escala cuantitativa{{ formData.estado !== 'no_existe' ? ' *' : '' }}</label>
        <input
          type="text"
          v-model="formData.escala_cuantitativa"
          :required="formData.estado !== 'no_existe'"
          :disabled="formData.estado === 'no_existe'"
          placeholder="Ej: 0-100, 1-5, Porcentaje"
          class="form-control"
        />
      </div>

      <!-- ── Cálculo de la nota ──────────────────────────────────────
           Dos formas de obtener el % de cumplimiento; la conversión a
           nota es la misma en ambas. -->
      <div class="fila" v-if="formData.estado !== 'no_existe'">
        <label>¿Cómo se calcula la nota? <span class="opcional">(opcional)</span></label>
        <select v-model="formData.metodo_calculo" class="form-control">
          <option :value="null">— A mano, sin cálculo —</option>
          <option value="por_periodos">Por periodos (valorar año por año)</option>
          <option value="directo">Directo (logro sobre meta)</option>
        </select>
      </div>

      <!-- Método directo -->
      <div class="fila fila-doble" v-if="formData.metodo_calculo === 'directo'">
        <div>
          <label>Logro alcanzado</label>
          <input type="number" step="0.01" v-model.number="formData.logro" class="form-control" placeholder="120" />
        </div>
        <div>
          <label>Meta planeada</label>
          <input type="number" step="0.01" v-model.number="formData.meta" class="form-control" placeholder="100" />
        </div>
      </div>

      <!-- Periodos del método por años, EN EL MISMO formulario: antes había
           que guardar la ficha y volver a entrar, y quien se perdía en ese
           salto acababa cargando la ficha dos veces. -->
      <div class="fila" v-if="formData.metodo_calculo === 'por_periodos'">
        <label>Periodos a valorar</label>
        <table v-if="periodosNuevos.length" class="tabla-periodos">
          <thead>
            <tr><th>Periodo</th><th>Valoración</th><th>Puntos</th><th></th></tr>
          </thead>
          <tbody>
            <tr v-for="(p, i) in periodosNuevos" :key="i">
              <td>{{ p.periodo }}</td>
              <td>{{ p.valoracion }}</td>
              <td>{{ puntosDe(p.valoracion) ?? '—' }}</td>
              <td><button type="button" class="btn-quitar" @click="quitarPeriodoNuevo(i)">×</button></td>
            </tr>
          </tbody>
        </table>
        <p v-else class="sin-periodos">Agrega un periodo por cada año (o semestre) que vayas a valorar.</p>

        <div class="nuevo-periodo">
          <input
            v-model="periodoEnEdicion.periodo"
            class="form-control"
            placeholder="2024"
            @keyup.enter.prevent="agregarPeriodoNuevo"
          />
          <select v-model="periodoEnEdicion.valoracion" class="form-control">
            <option value="" disabled>Valoración…</option>
            <option v-for="e in etiquetas" :key="e.valoracion" :value="e.valoracion">
              {{ e.valoracion }} ({{ e.puntos }})
            </option>
          </select>
          <button
            type="button"
            class="btn guardar btn-sm-accion"
            :disabled="!periodoEnEdicion.periodo || !periodoEnEdicion.valoracion"
            @click="agregarPeriodoNuevo"
          >
            Agregar
          </button>
        </div>
      </div>

      <!-- Nota que dará la ficha, calculada por el backend mientras se llena -->
      <div v-if="notaPrevia" class="nota-cuantitativa nota-previa">
        <template v-if="notaPrevia.nota != null">
          <div class="nc-cab">
            <span class="nc-valor">{{ notaPrevia.nota.toFixed(2) }}</span>
            <span class="nc-lbl">
              nota que quedará registrada ·
              {{ notaPrevia.desglose?.porcentaje_cumplimiento?.toFixed(2) }}% de cumplimiento
              <template v-if="notaPrevia.desglose?.tendencia">
                · {{ notaPrevia.desglose.tendencia.tendencia }}
              </template>
            </span>
          </div>
          <p v-if="notaPrevia.desglose?.topado_al_100" class="nc-aviso">
            El cumplimiento real fue {{ notaPrevia.desglose.porcentaje_sin_tope }}%; superar la meta
            no da más del máximo, así que se toma 100%.
          </p>
        </template>
        <p v-else class="nc-sin">{{ notaPrevia.motivo }}</p>
      </div>

      <!-- Detalle -->
      <div class="fila">
        <label>Detalle de la ficha</label>
        <textarea 
          v-model="formData.detalle"
          :disabled="formData.estado === 'no_existe'"
          placeholder="Explicación de los datos estadísticos"
          class="form-control"
        ></textarea>
      </div>

      <!-- Observaciones -->
      <div class="fila">
        <label>Observaciones</label>
        <textarea 
          v-model="formData.observaciones"
          :disabled="formData.estado === 'no_existe'"
          placeholder="Notas adicionales"
          class="form-control"
        ></textarea>
      </div>

      <!-- Botones -->
      <div class="botones">
        <button type="button" class="btn salir" @click="idInstrumento != null ? emit('cerrar') : router.back()">
          {{ idInstrumento != null ? 'Cerrar' : 'Volver' }}
        </button>
        <button type="submit" class="btn guardar">Guardar Ficha</button>
      </div>
    </form>

    <!-- Componente de confirmación -->
    <MensajeConfirmacion
      :visible="showConfirmacion"
      :title="tituloConfirmacion"
      :message="mensajeConfirmacion"
      confirmText="Confirmar"
      cancelText="Cancelar"
      @confirm="confirmarAccion"
      @cancel="cancelarAccion"
    />

    <MensajeFlotante
      :visible="mensajeVisible"
      :mensaje="mensajeTexto"
      :tipo="mensajeTipo"
      @cerrar="mensajeVisible = false"
    />
  </div>
</template>

<script lang="ts" setup>
/**
 * Ficha de evidencia cuantitativa.
 *
 * Dos métodos de cálculo: por periodos o directo (logro/meta). La nota la
 * recalcula el backend en cada cambio, así que tras editar hay que releerla.
 *
 * ── Enrutado ─────────────────────────────────────────────────────
 *   `/ficha-estadistica` (FichaEstadistica) — permiso `evidencias.subir`
 *
 * Componente de presentación. Recibe sus datos por props o del store del módulo.
 */

import { onMounted, ref, watch, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useGestionFichas } from '@/store/GestionFichas'
import { useGestionVersiones } from '@/store/GestionVersiones'
import { useModelo } from '@/store/GestionModelo'
import MensajeConfirmacion from '@/components/MensajeConfirmacion.vue'
import MensajeFlotante from '@/components/MensajeFlotante.vue'
import type { Ficha } from '@/interfaces/Ficha'
import {
  getPeriodosService,
  crearPeriodoService,
  eliminarPeriodoService,
  getEtiquetasValoracionService,
  simularNotaCuantitativaService
} from '@/services/FichasService'
import type {
  ValoracionPeriodo,
  EtiquetaValoracion,
  NotaCuantitativa,
  PeriodoNuevo
} from '@/services/FichasService'

interface RutaNodo { tipo: string; ordinal: string; nombre: string }

const props = withDefaults(defineProps<{
  idInstrumento?: number | null
  nombreVersion?: string
  rutaComponente?: RutaNodo[]
  nombreIndicador?: string
}>(), { idInstrumento: null })
const emit = defineEmits<{ (e: 'cerrar'): void }>()

const fichaStore = useGestionFichas()
const versionesStore = useGestionVersiones()
const modeloStore = useModelo()
const route = useRoute()
const router = useRouter()
const loading = ref(false)
const subiendo = ref<number | null>(null)
const renombrandoId = ref<number | null>(null)
const fichasRecienCreadas = ref<number[]>([])
const nuevoNombre = ref('')

function iniciarRenombrar(f: Ficha) {
  renombrandoId.value = f.id_ficha!
  nuevoNombre.value = f.nombre_visible ?? f.nombre_documento ?? ''
}

function cancelarRename() {
  renombrandoId.value = null
  nuevoNombre.value = ''
}

async function guardarNombre(idFicha: number) {
  const nombre = nuevoNombre.value.trim()
  if (!nombre) { cancelarRename(); return }
  const resultado = await fichaStore.actualizarFicha(idFicha, { nombre_documento: nombre })
  if (resultado) {
    mostrarMensaje('Nombre actualizado', 'positivo')
    await cargarFichas()
  } else {
    mostrarMensaje('Error al actualizar el nombre', 'error')
  }
  cancelarRename()
}
const archivoSeleccionado = ref<File | null>(null)
const fileInputRef = ref<HTMLInputElement | null>(null)

const fichasLocales = ref<Ficha[]>([])

const fichasUnicas = computed(() => {
  const vistas = new Set<number>()
  return fichasLocales.value.filter(f => {
    if (!f.id_ficha || vistas.has(f.id_ficha)) return false
    vistas.add(f.id_ficha)
    return true
  })
})


const mensajeVisible = ref(false)
const mensajeTexto = ref('')
const mensajeTipo = ref<'positivo' | 'error'>('positivo')

function mostrarMensaje(texto: string, tipo: 'positivo' | 'error') {
  mensajeTexto.value = texto
  mensajeTipo.value = tipo
  mensajeVisible.value = true
}

const formData = ref<Omit<Ficha, 'id_ficha' | 'tipo'> & {
  metodo_calculo?: string | null
  logro?: number | null
  meta?: number | null
}>({
  id_instrumento: 0,
  estado: 'existe',
  documento: '',
  fuente_datos: '',
  escala_cuantitativa: '',
  metodo_calculo: null,
  logro: null,
  meta: null,
  detalle: '',
  observaciones: '',
  fecha_registro: new Date().toISOString().split('T')[0]
})

// ── Cálculo de la nota ───────────────────────────────────────────────
/** Ficha cuyo panel de cálculo está abierto. */
const fichaCalculando = ref<number | null>(null)
const periodos = ref<ValoracionPeriodo[]>([])
const etiquetas = ref<EtiquetaValoracion[]>([])
const notaCalculada = ref<NotaCuantitativa | null>(null)
const nuevoPeriodo = ref({ periodo: '', valoracion: '' })

// Periodos de la ficha que TODAVÍA no existe: se acumulan en el formulario y
// viajan en el mismo POST que la ficha.
const periodosNuevos = ref<PeriodoNuevo[]>([])
const periodoEnEdicion = ref<PeriodoNuevo>({ periodo: '', valoracion: '' })
const notaPrevia = ref<NotaCuantitativa | null>(null)
/** Escala del modelo; la simulación la necesita para dar la nota correcta. */
const escalaMaxModelo = ref<number>(5)

function puntosDe(valoracion: string): number | null {
  return etiquetas.value.find(e => e.valoracion === valoracion)?.puntos ?? null
}

function etiquetaMetodo(metodo?: string | null): string {
  if (metodo === 'por_periodos') return 'por periodos'
  if (metodo === 'directo') return 'logro/meta'
  return ''
}

function agregarPeriodoNuevo() {
  const { periodo, valoracion } = periodoEnEdicion.value
  if (!periodo || !valoracion) return
  periodosNuevos.value.push({ periodo, valoracion })
  periodoEnEdicion.value = { periodo: '', valoracion: '' }
}

function quitarPeriodoNuevo(indice: number) {
  periodosNuevos.value.splice(indice, 1)
}

/**
 * Pide al backend la nota que dará el cálculo tal como está.
 *
 * El cálculo NO se replica aquí: la nota que se muestra mientras se llena el
 * formulario y la que se guarda al confirmar salen del mismo servicio.
 */
async function refrescarNotaPrevia() {
  const metodo = formData.value.metodo_calculo
  if (metodo !== 'por_periodos' && metodo !== 'directo') {
    notaPrevia.value = null
    return
  }
  if (metodo === 'por_periodos' && !periodosNuevos.value.length) {
    notaPrevia.value = null
    return
  }
  if (metodo === 'directo' && (formData.value.logro == null || formData.value.meta == null)) {
    notaPrevia.value = null
    return
  }

  notaPrevia.value = await simularNotaCuantitativaService({
    metodo_calculo: metodo,
    logro: formData.value.logro ?? null,
    meta: formData.value.meta ?? null,
    escala_max: escalaMaxModelo.value,
    periodos: periodosNuevos.value
  })
}

watch(
  () => [formData.value.metodo_calculo, formData.value.logro, formData.value.meta, periodosNuevos.value.length],
  () => { refrescarNotaPrevia() }
)

// Método de la ficha abierta en el panel, editable sin salir de él.
const metodoDelPanel = ref<string | null>(null)
const logroDelPanel = ref<number | null>(null)
const metaDelPanel = ref<number | null>(null)

async function abrirCalculo(idFicha: number) {
  fichaCalculando.value = idFicha
  nuevoPeriodo.value = { periodo: '', valoracion: '' }
  await cargarCalculo()
}

function cerrarCalculo() {
  fichaCalculando.value = null
  periodos.value = []
  notaCalculada.value = null
  metodoDelPanel.value = null
}

async function cargarCalculo() {
  const id = fichaCalculando.value
  if (!id) return
  const datos = await getPeriodosService(id)
  if (!datos) return
  periodos.value = datos.periodos
  if (datos.etiquetas?.length) etiquetas.value = datos.etiquetas
  notaCalculada.value = datos.nota_sugerida
  metodoDelPanel.value = datos.metodo_calculo
  logroDelPanel.value = datos.logro
  metaDelPanel.value = datos.meta
}

/** Guarda el método en la ficha existente y refresca su nota. */
async function guardarMetodoDelPanel() {
  const id = fichaCalculando.value
  if (!id) return

  const actualizada = await fichaStore.actualizarFicha(id, {
    metodo_calculo: metodoDelPanel.value as Ficha['metodo_calculo'],
    logro: metodoDelPanel.value === 'directo' ? logroDelPanel.value : null,
    meta: metodoDelPanel.value === 'directo' ? metaDelPanel.value : null
  })

  if (!actualizada) {
    mostrarMensaje('No se pudo guardar el método de cálculo', 'error')
    return
  }
  await cargarCalculo()
  await cargarFichas()
}

async function agregarPeriodo() {
  const id = fichaCalculando.value
  if (!id) return
  if (await crearPeriodoService(id, { ...nuevoPeriodo.value })) {
    nuevoPeriodo.value = { periodo: '', valoracion: '' }
    await cargarCalculo()
  }
}

async function quitarPeriodo(idValoracion: number) {
  if (await eliminarPeriodoService(idValoracion)) await cargarCalculo()
}

// Control de confirmación y toast
const showConfirmacion = ref(false)
const tituloConfirmacion = ref('')
const mensajeConfirmacion = ref('')
let accionPendiente: (() => Promise<void>) | null = null

function parseInstrumentoId(input: unknown): number | null {
  if (input === null || input === undefined) return null
  const raw = Array.isArray(input) ? input[0] : input
  const value = typeof raw === 'string' ? Number(raw) : typeof raw === 'number' ? raw : Number(String(raw))
  return Number.isFinite(value) && value > 0 ? value : null
}

async function cargarFichas() {
  const id = parseInstrumentoId(
    props.idInstrumento ??
    (route.query as any).id_instrumento ??
    (route.params as any).id_instrumento ??
    (route.params as any).id
  )
  if (!id) {
    mostrarMensaje('No se encontró id_instrumento en la URL.', 'error')
    return
  }

  formData.value.id_instrumento = id
  loading.value = true
  try {
    fichasLocales.value = (await fichaStore.listarFichas({ id_instrumento: id, tipo: 'estadistica' })) ?? []
  } finally {
    loading.value = false
  }
}

async function cargarEscalaModelo() {
  const rawVersion = route.params.id_version ?? route.query.id_version
  const idVersion = Number(Array.isArray(rawVersion) ? rawVersion[0] : rawVersion)
  if (!Number.isFinite(idVersion) || idVersion <= 0) return
  try {
    const version = await versionesStore.getVersionById(idVersion)
    const idModelo = (version as any)?.id_modelo
    if (!idModelo) return
    const modelo = await modeloStore.getModeloById(idModelo)
    const escalaMax = modelo?.escala_max
    if (!escalaMax) return
    escalaMaxModelo.value = escalaMax
    const texto = escalaMax > 5 ? `1 - ${escalaMax}` : `0 - ${escalaMax}`
    if (!formData.value.escala_cuantitativa?.trim()) {
      formData.value.escala_cuantitativa = texto
    }
  } catch { /* noop */ }
}

onMounted(async () => {
  cargarFichas()
  cargarEscalaModelo()
  // Las valoraciones se cargan de entrada: el formulario tiene que ofrecerlas
  // sin que exista todavía ninguna ficha.
  etiquetas.value = await getEtiquetasValoracionService()
})

watch(() => props.idInstrumento, (val) => {
  if (val != null) cargarFichas()
})

async function guardarFicha() {
  if (!formData.value.id_instrumento || formData.value.id_instrumento <= 0) {
    mostrarMensaje('id_instrumento es requerido para crear la ficha.', 'error')
    return
  }

  if (!formData.value.estado) {
    mostrarMensaje('Por favor seleccione un estado', 'error')
    return
  }

  if (formData.value.estado !== 'no_existe') {
    if (!formData.value.fuente_datos?.trim()) {
      mostrarMensaje('Fuente de datos es requerida', 'error')
      return
    }
    if (!formData.value.escala_cuantitativa?.trim()) {
      mostrarMensaje('Escala cuantitativa es requerida', 'error')
      return
    }
  }

  tituloConfirmacion.value = 'Guardar Ficha Estadística'
  mensajeConfirmacion.value = '¿Está seguro de que desea guardar esta ficha?'
  
  accionPendiente = async () => {
    const docValue = archivoSeleccionado.value
      ? 'pendiente-upload'
      : (formData.value.documento || 'sin-documento')

    const noExiste = formData.value.estado === 'no_existe'
    const porPeriodos = formData.value.metodo_calculo === 'por_periodos'
    const payload: Omit<Ficha, 'id_ficha'> = {
      ...formData.value,
      documento: docValue,
      tipo: 'estadistica',
      // Los periodos van en la misma petición que la ficha: así nace con su
      // nota calculada y no hace falta un segundo paso.
      ...(porPeriodos && periodosNuevos.value.length ? { periodos: periodosNuevos.value } : {}),
      ...(noExiste ? { fuente_datos: 'Ninguna', escala_cuantitativa: '0' } : {})
    }

    const resultado = await fichaStore.crearFicha(payload)

    if (resultado.ok && resultado.ficha) {
      if (resultado.ficha.id_ficha) fichasRecienCreadas.value.push(resultado.ficha.id_ficha)
      if (archivoSeleccionado.value && resultado.ficha.id_ficha) {
        mostrarMensaje('Ficha creada. Subiendo archivo...', 'positivo')
        const uploadResult = await fichaStore.uploadArchivo(resultado.ficha.id_ficha, archivoSeleccionado.value)
        if (uploadResult.ok) {
          mostrarMensaje('Ficha guardada y archivo subido exitosamente', 'positivo')
        } else {
          mostrarMensaje(uploadResult.error || 'Ficha creada pero error al subir archivo', 'error')
        }
      } else {
        mostrarMensaje('Ficha estadística guardada exitosamente', 'positivo')
      }
      archivoSeleccionado.value = null
      limpiarFormulario()
      cargarEscalaModelo()
      await cargarFichas()
    } else {
      mostrarMensaje(resultado.error || 'Error al guardar la ficha', 'error')
    }
  }

  showConfirmacion.value = true
}

function limpiarFormulario() {
  formData.value = {
    id_instrumento: 0,
    estado: 'existe',
    documento: '',
    fuente_datos: '',
    escala_cuantitativa: '',
    // Se reinician explícitamente: al omitirlos, el método y los datos de
    // cálculo de una ficha se arrastraban a la siguiente.
    metodo_calculo: null,
    logro: null,
    meta: null,
    detalle: '',
    observaciones: '',
    fecha_registro: new Date().toISOString().split('T')[0]
  }
  periodosNuevos.value = []
  periodoEnEdicion.value = { periodo: '', valoracion: '' }
  notaPrevia.value = null
}

function abrirConfirmacionEliminar(id: number | undefined) {
  if (!id) return

  tituloConfirmacion.value = 'Eliminar Ficha'
  mensajeConfirmacion.value = '¿Está seguro de que desea eliminar esta ficha? Esta acción no se puede deshacer.'
  
  accionPendiente = async () => {
    const resultado = await fichaStore.eliminarFicha(id)
    
    if (resultado) {
      mostrarMensaje('Ficha eliminada exitosamente', 'positivo')
      await cargarFichas()
    } else {
      mostrarMensaje('Error al eliminar la ficha', 'error')
    }
  }

  showConfirmacion.value = true
}

function confirmarAccion() {
  showConfirmacion.value = false
  if (accionPendiente) {
    accionPendiente()
    accionPendiente = null
  }
}

function cancelarAccion() {
  showConfirmacion.value = false
  accionPendiente = null
}

function onFileSelected(event: Event) {
  const input = event.target as HTMLInputElement
  const file = input.files?.[0]
  if (file) archivoSeleccionado.value = file
}

function quitarArchivo() {
  archivoSeleccionado.value = null
  if (fileInputRef.value) fileInputRef.value.value = ''
}

function reutilizarFicha(f: Ficha) {
  archivoSeleccionado.value = null
  if (fileInputRef.value) fileInputRef.value.value = ''
  formData.value = {
    id_instrumento: formData.value.id_instrumento,
    estado: f.estado ?? '',
    documento: (f.documento && f.documento !== 'sin-documento' && f.documento !== 'pendiente-upload')
      ? f.documento
      : '',
    fuente_datos: f.fuente_datos ?? '',
    escala_cuantitativa: f.escala_cuantitativa ?? '',
    detalle: f.detalle ?? '',
    observaciones: f.observaciones ?? '',
    descripcion: f.descripcion ?? '',
    fecha_registro: new Date().toISOString().split('T')[0]
  }
  document.querySelector<HTMLElement>('.ficha-form')?.scrollIntoView({ behavior: 'smooth' })
}

async function subirArchivo(idFicha: number, event: Event) {
  const input = event.target as HTMLInputElement
  const file = input.files?.[0]
  if (!file || !idFicha) return

  subiendo.value = idFicha
  try {
    const result = await fichaStore.uploadArchivo(idFicha, file)
    if (result.ok) {
      mostrarMensaje('Archivo subido exitosamente', 'positivo')
    } else {
      mostrarMensaje(result.error || 'Error al subir archivo', 'error')
    }
    await cargarFichas()
  } finally {
    subiendo.value = null
    input.value = ''
  }
}
</script>

<style scoped>
.formulario-modelo {
  background-color: white;
  padding: 2rem;
  border-radius: var(--radius-lg);
  width: 95%;
  height: 100%;
  overflow-y: auto;
  box-shadow: var(--shadow-md);
  box-sizing: border-box;
  margin: 20px auto;
  font-family: var(--font-family);
  max-width: 900px;
}

.titulo-ficha {
  margin-bottom: 0.5rem;
  font-size: 1.4rem;
}

.ctx-strip {
  display: flex;
  flex-direction: column;
  gap: 3px;
  padding: 8px 12px;
  margin: 0.5rem 0;
  background: #e8f0f8;
  border-left: 3px solid #0e69a0;
  border-radius: 3px;
}
.ctx-version { font-size: 0.8rem; font-weight: 700; color: #111; margin-bottom: 4px; }
.ctx-ruta-nodo { display: flex; align-items: baseline; gap: 6px; }
.ctx-ruta-tipo { font-size: 0.7rem; font-weight: 700; color: #0e69a0; text-transform: uppercase; letter-spacing: 0.04em; min-width: 88px; flex-shrink: 0; }
.ctx-ruta-ordinal { font-size: 0.78rem; font-weight: 700; color: #555; min-width: 28px; flex-shrink: 0; }
.ctx-ruta-nombre { font-size: 0.78rem; color: #333; }
.ctx-indicador-row { margin-top: 4px; padding-top: 4px; border-top: 1px solid #c5d8ec; }
.ctx-indicador { font-size: 0.8rem; font-weight: 600; color: #111; }

.header-flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.divider {
  border-bottom: 1px solid #949393;
  margin: 8px 0 16px;
}

.contenedor-tabla {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  margin-bottom: 2rem;
}

.info {
  padding: 0.5rem 0;
  color: #333;
}

.mensaje-vacio {
  margin-top: 0.5rem;
  color: #555;
}

.lista-tabla {
  width: 100%;
  min-width: 800px;
  border-collapse: collapse;
  table-layout: auto;
}

.lista-tabla td,
.lista-tabla th {
  padding: 12px 16px;
  text-align: left;
  border-bottom: 1px solid #e0e0e0;
  font-size: 14px;
  vertical-align: middle;
}

.lista-tabla thead {
  background-color: #e2e2e2;
  font-weight: 600;
  text-transform: uppercase;
  font-size: 0.75rem;
  letter-spacing: 0.05em;
}

.toggle-group {
  display: flex;
  gap: 1.5rem;
  margin-top: 0.5rem;
  flex-wrap: wrap;
}

.toggle-label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  font-weight: normal;
}

.toggle-label input[type="radio"] {
  cursor: pointer;
}

.badge {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 4px;
  font-weight: 600;
  font-size: 0.85rem;
  letter-spacing: 0.03em;
}

.badge-existe { 
  background-color: #d4edda;
  color: #155724;
}

.badge-no_existe { 
  background-color: #f8d7da;
  color: #721c24;
}

.ficha-form {
  margin-top: 2rem;
  padding-top: 1.5rem;
  border-top: 1px solid #e0e0e0;
}

.ficha-form h3 {
  margin-bottom: 1rem;
  font-size: 1.1rem;
}

.fila {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 1rem;
}

.fila > label {
  font-weight: 600;
  color: #333;
}

.form-control {
  padding: 0.75rem;
  background: white;
  border-radius: 8px;
  border: 1px solid #ececec;
  font-size: 1rem;
  font-family: inherit;
  color: inherit;
  transition: border-color var(--transition-fast), box-shadow var(--transition-fast);
}

.form-control:focus {
  outline: none;
  border-color: #0e69a0;
  box-shadow: 0 0 0 3px rgba(14, 105, 160, 0.1);
}

.form-control:disabled {
  background-color: #f5f5f5;
  color: #999;
  cursor: not-allowed;
}

textarea.form-control {
  min-height: 80px;
  resize: vertical;
}

.botones {
  display: flex;
  gap: 1rem;
  margin-top: 1.5rem;
  justify-content: flex-end;
}

.btn {
  padding: 0.5rem 0.9rem;
  font-weight: 600;
  border: none;
  border-radius: var(--radius-md);
  cursor: pointer;
  font-family: inherit;
  font-size: inherit;
  line-height: 1.2;
  box-sizing: border-box;
  transition: all var(--transition-fast);
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
}

.btn.salir {
  background-color: white;
  border: 1px solid #ccc;
  color: #333;
}

.btn.salir:hover {
  background-color: rgb(212, 26, 26);
  color: white;
  border-color: rgb(212, 26, 26);
}

.btn.guardar {
  background-color: #eea222;
  color: black;
}

.btn.guardar:hover {
  background-color: #0e69a0;
  color: white;
}

.btn.guardar:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.btn.guardar:hover {
  background-color: #0e69a0;
  color: white;
}

.acciones-ficha {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
  align-items: center;
}

.btn-sm-accion {
  font-size: 0.8rem;
  padding: 0.35rem 0.7rem;
  height: auto;
}

.btn-upload {
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  font-size: 0.85rem;
  padding: 0.5rem 0.9rem;
}

.btn-upload.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.upload-area {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.upload-area.disabled {
  opacity: 0.5;
  pointer-events: none;
}

.upload-label {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.65rem 1rem;
  background-color: #f0f4f8;
  border: 2px dashed #b0c4d8;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.9rem;
  color: #333;
  transition: all 0.15s ease;
  flex: 1;
  min-width: 200px;
}

.upload-label:hover { background-color: #e1ecf4; border-color: #0e69a0; }
.upload-label.disabled { cursor: not-allowed; opacity: 0.5; }
.upload-icon { font-size: 1.2rem; }

.btn-quitar {
  padding: 0.4rem 0.75rem;
  background: white;
  border: 1px solid #ccc;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.85rem;
  transition: all 0.15s ease;
}

.btn-quitar:hover { background-color: #dc3545; color: white; border-color: #dc3545; }
.hint { color: #888; font-size: 0.8rem; font-style: italic; }

.aviso-historico {
  background: #e8f1f8;
  border: 1px solid #b0cfe8;
  border-left: 4px solid #0e69a0;
  border-radius: 6px;
  padding: 0.85rem 1rem;
  margin-bottom: 1.25rem;
}

.aviso-historico-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.35rem;
}

.aviso-historico-titulo {
  font-size: 0.88rem;
  font-weight: 700;
  color: #0e69a0;
}

.aviso-cerrar {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 0.85rem;
  color: #666;
  padding: 0;
  line-height: 1;
}

.aviso-cerrar:hover { color: #333; }

.aviso-historico-desc {
  font-size: 0.83rem;
  color: #444;
  margin: 0 0 0.6rem;
}

.aviso-historico-items {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.aviso-historico-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  background: white;
  border: 1px solid #d0e5f5;
  border-radius: 4px;
  padding: 0.4rem 0.75rem;
}

.aviso-historico-info {
  font-size: 0.83rem;
  color: #333;
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.aviso-historico-acciones {
  display: flex;
  gap: 0.5rem;
  flex-shrink: 0;
}

.btn-ver {
  font-size: 0.78rem;
  padding: 0.28rem 0.6rem;
  background: #f0f4f8;
  border: 1px solid #b0c4d8;
  border-radius: var(--radius-md);
  color: #0e69a0;
  text-decoration: none;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  transition: all 0.15s ease;
}

.btn-ver:hover {
  background: #0e69a0;
  color: white;
  border-color: #0e69a0;
}

.link-doc {
  color: #0e69a0;
  text-decoration: underline;
  font-weight: 500;
}
.link-doc:hover {
  color: #094d75;
}

.doc-celda { min-width: 160px; }

.rename-row {
  display: flex;
  gap: 4px;
  align-items: center;
  flex-wrap: nowrap;
}

.input-nombre {
  flex: 1;
  padding: 3px 6px;
  border: 1px solid #0e69a0;
  border-radius: 4px;
  font-size: 0.82rem;
  min-width: 0;
  font-family: inherit;
}

.badge-origen {
  font-size: 0.68rem;
  font-weight: 700;
  padding: 1px 5px;
  border-radius: 3px;
  margin-left: 4px;
  white-space: nowrap;
  vertical-align: middle;
}

.badge-origen.externo {
  background: #fdf3e1;
  color: #a07010;
  border: 1px solid #f5c96a;
}

.badge-origen.desconocido {
  background: #fde8e8;
  color: #a32d2d;
  border: 1px solid #f5c6c6;
}

.badge-formato {
  font-size: 0.65rem;
  font-weight: 700;
  padding: 1px 5px;
  border-radius: 3px;
  background: #e8f2f9;
  color: #0e5480;
  border: 1px solid #b8d8ee;
  margin-left: 4px;
  vertical-align: middle;
}
/* Panel de cálculo de la ficha cuantitativa */
.panel-calculo { border: 1px solid #d9e1ea; border-radius: 8px; padding: 0.9rem 1rem; margin-top: 1rem; background: #fbfdff; }
.pc-cab { display: flex; justify-content: space-between; align-items: center; margin-bottom: 0.7rem; }
.pc-cab h3 { margin: 0; font-size: 0.95rem; color: #14507d; }
.tabla-periodos { width: 100%; border-collapse: collapse; font-size: 0.82rem; margin-bottom: 0.6rem; }
.tabla-periodos th, .tabla-periodos td { text-align: left; padding: 0.3rem 0.5rem; border-bottom: 1px solid #e6eef5; }
.sin-periodos { font-size: 0.8rem; color: #888; font-style: italic; margin: 0 0 0.6rem; }
.nuevo-periodo { display: flex; gap: 0.5rem; align-items: center; flex-wrap: wrap; }
.nuevo-periodo .form-control { flex: 1; min-width: 8rem; }
.btn-quitar { border: none; background: none; color: #c0392b; font-size: 1.1rem; cursor: pointer; line-height: 1; }
.aviso-guardar { font-size: 0.78rem; color: #b06000; margin: 0.3rem 0 0; }
.fila-doble { display: grid; grid-template-columns: 1fr 1fr; gap: 0.8rem; }
.opcional { font-weight: 400; font-size: 0.78rem; color: #9aa5b1; }
.nota-cuantitativa { border: 1px solid #cfe6d4; background: #f4fbf6; border-radius: 8px; padding: 0.6rem 0.75rem; margin-top: 0.8rem; }
.nc-cab { display: flex; align-items: center; gap: 0.7rem; flex-wrap: wrap; }
.nc-valor { font-size: 1.4rem; font-weight: 800; color: #1d7a3a; line-height: 1; }
.nc-lbl { font-size: 0.8rem; color: #4a5b6b; }
.nc-aviso { margin: 0.4rem 0 0; font-size: 0.76rem; color: #b06000; }
.nc-sin { margin: 0; font-size: 0.8rem; color: #888; font-style: italic; }

/* Método de cálculo editable dentro del panel de una ficha ya guardada */
.pc-metodo { display: flex; gap: 0.5rem; align-items: center; flex-wrap: wrap; margin-bottom: 0.8rem; }
.pc-metodo label { font-size: 0.8rem; color: #4a5b6b; white-space: nowrap; }
.pc-metodo .form-control { flex: 1; min-width: 10rem; }
.input-corto { max-width: 7rem; }

/* Nota mientras se llena el formulario y nota en la lista de fichas */
.nota-previa { margin-bottom: 0.8rem; }
.celda-nota { white-space: nowrap; }
.nota-chip {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 999px;
  background: #e7f6ec;
  color: #1d7a3a;
  font-weight: 700;
  font-size: 0.85rem;
}
.nota-chip--vacia { background: #f0f2f5; color: #9aa5b1; font-weight: 500; }
.nota-metodo { display: block; font-size: 0.7rem; color: #9aa5b1; margin-top: 2px; }
.link-descargar {
  display: inline-block;
  margin-left: 0.4rem;
  color: #0e69a0;
  text-decoration: none;
  font-size: 0.85rem;
  opacity: 0.75;
}
.link-descargar:hover { opacity: 1; }

</style>
